import { Text } from "@mantine/core";

import { useSpotlightKeyboardShortcutLabels } from "@/hooks/common/useSpotlightKeyboardShortcutLabels";

import classes from "./SpotlightKeyboardShortcuts.module.css";

type KeycapProps = {
  readonly children: string;
  readonly wide?: boolean;
};

/**
 * Single keycap cell for shortcut helper rows.
 * @agentic connections
 */
const Keycap = ({ children, wide }: KeycapProps) => (
  <span
    className={`${classes.keycap} ${wide ? classes.keycapWide : ""}`}
    aria-hidden="true"
  >
    {children}
  </span>
);

/**
 * Gradient shortcut legend rendered above the patient spotlight search field.
 * @agentic connections
 */
export const SpotlightKeyboardShortcuts = () => {
  const { searchModifierLabel, selectKeyLabel } =
    useSpotlightKeyboardShortcutLabels();

  return (
    <div
      className={classes.strip}
      role="region"
      aria-label="Spotlight keyboard shortcuts"
    >
      <div className={classes.column}>
        <Text component="span" className={classes.label}>
          search
        </Text>
        <div className={classes.keysRow}>
          <Keycap>{searchModifierLabel}</Keycap>
          <span className={classes.plus} aria-hidden="true">
            +
          </span>
          <Keycap>K</Keycap>
        </div>
      </div>

      <div className={classes.column}>
        <Text component="span" className={classes.label}>
          up/down
        </Text>
        <div className={classes.keysRow}>
          <Keycap>↑</Keycap>
          <Keycap>↓</Keycap>
        </div>
      </div>

      <div className={classes.column}>
        <Text component="span" className={classes.label}>
          select
        </Text>
        <div className={classes.keysRow}>
          <Keycap wide>{selectKeyLabel}</Keycap>
        </div>
      </div>
    </div>
  );
};
